module.exports = __webpack_public_path__ + "static/media/list-and-earn.c3b6b195.svg";